import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MSAssignmentsStatusOptions } from 'src/interfaces/assignment.types';
import { useActiveMSAssignmentsStatus } from 'src/store/features';

import './no-middle-school-assignments-card.scss';

const imagesSourcesMap = {
  cat: 'https://learning.amplify.com/m/231f4bcc962284d/original/sh-ms-no-assignments-cat.gif',
  chameleon:
    'https://learning.amplify.com/m/24b0405fa93c60c8/original/sh-ms-no-assignments-chameleon.gif',
  dog: 'https://learning.amplify.com/m/4ab8b21baef88398/original/sh-ms-no-assignments-dog.gif',
};

const NoMiddleSchoolAssignmentsCard = () => {
  const { t } = useTranslation();
  const [hasGifLoaded, setHasGifLoaded] = useState(false);

  const activeMSAssignmentsStatus = useActiveMSAssignmentsStatus();

  const getCardTitle = () => {
    if (activeMSAssignmentsStatus === MSAssignmentsStatusOptions.STARTED) {
      return t('You haven’t started any assignments yet!');
    }

    if (activeMSAssignmentsStatus === MSAssignmentsStatusOptions.HANDED_IN) {
      return t('You haven’t handed in any assignments yet!');
    }

    if (activeMSAssignmentsStatus === MSAssignmentsStatusOptions.NOT_STARTED) {
      return t('You don’t have any new assignments!');
    }

    return t('When your teacher sends an assignment, it will appear here.');
  };

  const getCardImageSrc = () => {
    const images = Object.keys(
      imagesSourcesMap,
    ) as (keyof typeof imagesSourcesMap)[];

    const randomNumber = Math.floor(Math.random() * images.length);
    const randomImage = images[randomNumber];

    return imagesSourcesMap[randomImage];
  };

  return (
    <div className="no-middle-school-assignments-card">
      {hasGifLoaded && (
        <span className="no-middle-school-assignments-card__title">
          {getCardTitle()}
        </span>
      )}
      <img
        className="no-middle-school-assignments-card__image"
        src={getCardImageSrc()}
        alt=""
        onLoad={() => setHasGifLoaded(true)}
        data-testid="no-middle-school-assignments-card-image"
      />
    </div>
  );
};

const MemoizedNoMiddleSchoolAssignmentsCard = memo(
  NoMiddleSchoolAssignmentsCard,
);

export default MemoizedNoMiddleSchoolAssignmentsCard;
